module.exports = __webpack_public_path__ + "img/wonderindian_tech_Normal_ua.156f0e73.webp";